import React from 'react';
import AppStateProvider, { useAppState } from '../../../src/state';
import { VideoProvider } from './VideoProvider';
import generateConnectionOptions from '../../../src/utils/generateConnectionOptions/generateConnectionOptions';
const AlucioVideoProvider = (props) => {
    const { children } = props;
    const { setError, settings } = useAppState();
    const connectionOptions = generateConnectionOptions(settings);
    return (React.createElement(VideoProvider, { options: connectionOptions, onError: setError }, children));
};
const WithAppState = (Component) => (props) => {
    return (
    /* maxTracks we need one additional spot because when the app is in sharing mode, a track is taken for sharing screen
      id we don't do this one of the participants will get freeze
    */
    React.createElement(AppStateProvider, { settings: { maxTracks: '6' } },
        React.createElement(Component, Object.assign({}, props))));
};
export default WithAppState(AlucioVideoProvider);
//# sourceMappingURL=AlucioVideoProvider.js.map